import { timeParse } from "d3";

export const parseDate = timeParse("%d/%m/%y");
export const parseDateFullYear = timeParse("%d/%m/%Y");

export const accessors = {
  attributeID: (d) => d.attributeID,
  id: (d) => d.id,
  association: (d) => d.association,
  allAssociations: (d) => d.allAssociations,
  attribute: {
    // Elements here don't exist in the original data
    // object and are built on the fly, to be consumed
    // by the visualization elements
    type: (d) => d.type,
    association: (d) => d.association,
  },
  // classification: (d) => d.classification,
  color: (d) => d.color,
  // content: (d) => d.content,
  description: (d) => d.description,
  date: {
    start: (d) => d.date.start,
    // end: (d) => d.date.end,
    fuzziness: (d) => d.date.fuzziness,
  },
  target: {
    association: (d) => d.target.association,
    name: (d) => d.target.name,
    // projects: (d) => d.target.projects,
  },
  sources: (d) => d.sources,
  opacity: (d) => d.opacity,
  opacityPerAssociation: (d) => d.opacityPerAssociation,
  // projects: (d) => d.projects,

  // NB this is different to the event type and refers to the descriptor
  // for what shape we render
  // TODO Make the field name more descriptive
  type: (d) => d.type,
  // fieldsOfOperation: (d) => d["fields_of_operation"],
  event: {
    place: (d) => d.event.place,
    type: (d) => d.event.type,
    // linked: (d) => d.event.linked,
  },
};
